import { IEvent } from "../../Interfaces/Event/IEvent";
import { IFilterValue } from "../../Interfaces/IFilterValue";
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import { IEventState } from "./IEventState";

export const getEvents = (eventState: IEventState): IEvent[] => eventState.events;
export const isLoadingEvents = (eventState: IEventState) => eventState.isLoadingEvents;
export const getLoadEventsError = (eventState: IEventState) => eventState.loadEventsError;

/**
 * Returns current value from state for: eventsFilterValues
 * @param userProfileState
 */
export const getEventsFilterValues = (eventState: IEventState): IFilterValue[] =>
  eventState.eventsFilterValues;

export const isLoadingSelectedEvent = (eventState: IEventState) =>
  eventState.isLoadingSelectedEvent;
export const getLoadSelectedEventError = (eventState: IEventState) =>
  eventState.loadSelectedEventError;

export const isUpdatingStatus = (userProfileState: IEventState) =>
  userProfileState.isUpdatingStatus;

export const getSelectedEvent = (eventState: IEventState) => eventState.selectedEvent;
export const getSelectedEventId = (eventState: IEventState) => eventState.selectedEventId;
export const getUpdateEventStatusError = (eventState: IEventState) =>
  eventState.updateEventStatusError;

/**
 * Returns current value from state for: currentPage
 * @param eventState
 */
export const getCurrentPage = (eventState: IEventState): number => eventState.currentPage;

/**
 * Returns current value from state for: pageSize
 * @param eventState
 */
export const getPageSize = (eventState: IEventState): number => eventState.pageSize;

/**
 * Returns current value from state for: searchText
 * @param eventState
 */
export const getSearchText = (eventState: IEventState): string => eventState.searchText;

/**
 * Returns the filtered count.
 * @param eventState
 */
export const getFilteredCount = (eventState: IEventState): number => eventState.filteredCount;
